import { render, staticRenderFns } from "./APIClient.vue?vue&type=template&id=22b5b6ba&scoped=true"
import script from "./APIClient.vue?vue&type=script&lang=js"
export * from "./APIClient.vue?vue&type=script&lang=js"
import style0 from "./APIClient.vue?vue&type=style&index=0&id=22b5b6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5b6ba",
  null
  
)

export default component.exports